module.exports = __webpack_public_path__ + "media/images/logo/aorta-lsp-eef1767aa4a20f62963f56bb9649c5b3.png";